/* eslint-disable react/no-multi-comp */
import React from 'react';
import { genders } from '../../../constants/inVenue';
import classNames from '@app/ui/sports-components/utils/classNames';

type LegendProps = {
  isLoading: boolean,
  onClick?: (param: 'Male' | 'Female' | null) => void,
  hidden?: 'Male' | 'Female' | null
}

const Legend = ({
  isLoading,
  onClick,
  hidden
}: LegendProps) => (
  <div className="stadium-attendance-game-legend-container">
    {!isLoading && <>
      {
        genders.map((gender) => {
          const circleClassName = classNames(
            'stadium-attendance-game-legend-circle',
            '-m-r-2',
            {
              [`stadium-attendance-game-legend-circle-${gender.toLowerCase()}`]: !!gender
            });

          const containerClassName = classNames(
            'stadium-attendance-game-legend',
            {
              '-cursor--pointer': !!onClick,
              '--strike-through': gender === hidden
            });

          const onGenderClick = () => {
            if (onClick) {
              onClick(gender);
            }
          };

          return (
            <div className={containerClassName} onClick={onGenderClick} key={`gender-legend-${gender}`}>
              <div className={
                circleClassName
              } />
              <p>{gender}</p>
            </div>
          );
        })
      }
    </>}
  </div>);

export default Legend;
